export default __webpack_public_path__ + "static/media/PreventionDatenschutzerklarung.d3297c30.md";